/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    var isValidDueDate = function(date) {
        var timeDate = new Date(date.replace(' ', 'T'));
        timeDate.setDate(timeDate.getDate()+1);
        var currentDate = new Date();
        return currentDate < timeDate;
    }

    switch(action.actionType)
    {
        case Constants.GET_CLASS_FAV_ASSIGNMENTS:
            this.favs = action.response;
            this.emit(Constants.GET_CLASS_FAV_ASSIGNMENTS);
            break;
        case Constants.DELETE_CLASS:
            this.classes = {};
            break;
        case Constants.DELETE_STUDENT:
            this.students = {};
            break;
        case Constants.GET_CLASS_ASSIGNMENTS:
            action.response =  action.response.assignments
            var assignmentArray = [];
            var archiveArray = [];
            for (var i = 0; i < action.response.length; i++) {
                if(isValidDueDate(action.response[i].due)) {
                    assignmentArray.push(action.response[i]);
                } else { 
                    archiveArray.push(action.response[i]);
                }
            }
            this.assignments = assignmentArray;
            this.archive2 = archiveArray;
            if (this.archive2 == undefined) {
                this.archived = this.archive1;
            } else {
                this.archived = this.archive2.concat(this.archive1);
            }
            
            this.emit(Constants.GET_CLASS_ASSIGNMENTS);
            this.emit(Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS);
            break;
        case Constants.GET_STUDENT_ASSIGNMENTS:
                var assignmentArray = [];
                for (var i = 0; i < action.response.length; i++) {
                    assignmentArray.push(action.response[i]);
                }
                this.studentAssignments = assignmentArray;
                
                this.emit(Constants.GET_STUDENT_ASSIGNMENTS);
                break;
        case Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS:
            this.archive1 = action.response || [];
            if (this.archive2 == undefined) {
                this.archived = this.archive1;
            } else {
                this.archived = this.archive2.concat(this.archive1);
            }
            this.emit(Constants.GET_CLASS_ARCHIVED_ASSIGNMENTS);
            break;
        case Constants.GET_MY_CLASSES:
            this.list = action.response || [];
            this.emit(Constants.GET_MY_CLASSES);
            break;
        case Constants.ON_CLASS_FETCH:
            this.classes[action.response.uid] =  action.response;
            this.emit(Constants.ON_CLASS_FETCH);
            break;
        case Constants.ON_MY_CLASSES_FETCH:
            this.classList = action.response || [];
            this.emit(Constants.ON_MY_CLASSES_FETCH);
            break;
        case Constants.GET_CLASS_GRAMMER_COMPLETED:
            this.grammerTable = action.response;
            this.emit(Constants.GET_CLASS_GRAMMER_COMPLETED);
            break;
        case Constants.GET_CLASS_VERB_COMPLETED:
            this.verbTable = action.response;
            this.emit(Constants.GET_CLASS_VERB_COMPLETED);
            break;
        case Constants.GET_CLASS_SENTENCE_COMPLETED:
            this.sentenceTable = action.response;
            this.emit(Constants.GET_CLASS_SENTENCE_COMPLETED);
            break;
        case Constants.GET_CLASS_PRONUNCIATION_COMPLETED:
            this.pronunciationTable = action.response;
            this.emit(Constants.GET_CLASS_PRONUNCIATION_COMPLETED);
            break;
        case Constants.GET_CLASS_EXAM_COMPLETED:
            this.examProgressTable = action.response;
            this.emit(Constants.GET_CLASS_EXAM_COMPLETED);
            break;
        case Constants.GET_CLASS_EXAM_QUESTION:
            this.examProgressTable = action.response;
            this.emit(Constants.GET_CLASS_EXAM_QUESTION);
            break;
        case Constants.GET_CLASS_VOCABULARY_COMPLETED:
            this.vocabularyProgressTable = action.response;
            this.emit(Constants.GET_CLASS_VOCABULARY_COMPLETED);
            break;
        case Constants.GET_CLASS_STUDENT_VOCABULARY_COMPLETED:
                this.vocabularyProgressTableStudent = action.response;
                this.emit(Constants.GET_CLASS_STUDENT_VOCABULARY_COMPLETED);
                break;
        case Constants.GET_CLASS_STUDENT_MYCONTENT_COMPLETED:
            this.myContentProgressTableStudent = action.response;
            this.emit(Constants.GET_CLASS_STUDENT_MYCONTENT_COMPLETED);
            break;
        case Constants.GET_CLASS_STUDENT_VERB_COMPLETED:
                this.verbProgressTableStudent = action.response;
                this.emit(Constants.GET_CLASS_STUDENT_VERB_COMPLETED);
                break;
        case Constants.GET_CLASS_STUDENT_SENTENCE_COMPLETED:
                this.sentenceProgressTableStudent = action.response;
                this.emit(Constants.GET_CLASS_STUDENT_SENTENCE_COMPLETED);
                break;
        case Constants.GET_CLASS_STUDENT_GRAMMAR_COMPLETED:
                this.grammarProgressTableStudent = action.response;
                this.emit(Constants.GET_CLASS_STUDENT_GRAMMAR_COMPLETED);
                break;
        case Constants.GET_CLASS_STUDENT_EXAM_COMPLETED:
                this.examProgressTableStudent = action.response;
                this.emit(Constants.GET_CLASS_STUDENT_EXAM_COMPLETED);
                break;
        case Constants.GET_CLASS_PROGRESS:
            this.progress = action.response;
            this.emit(Constants.GET_CLASS_PROGRESS);
            break;
        case Constants.GET_STUDENT_GRAMMER_COMPLETED:
            this.grammerStudentTable = action.response;
            this.emit(Constants.GET_STUDENT_GRAMMER_COMPLETED);
            break;
        case Constants.GET_STUDENT_PRONUNCIATION_COMPLETED:
            this.pronunciationStudentTable = action.response;
            this.emit(Constants.GET_STUDENT_PRONUNCIATION_COMPLETED);
            break;
        case Constants.GET_STUDENT_EXAM_COMPLETED:
            this.examStudentProgressTable = action.response;
            this.emit(Constants.GET_STUDENT_EXAM_COMPLETED);
            break;
        case Constants.GET_STUDENT_VOCABULARY_COMPLETED:
            this.vocabularyStudentProgressTable = action.response;
            this.emit(Constants.GET_STUDENT_VOCABULARY_COMPLETED);
            break;
        case Constants.GET_STUDENT_PROGRESS:
            this.progressStudent = action.response;
            this.emit(Constants.GET_STUDENT_PROGRESS);
            break;
        case Constants.GET_CLASS_ACTIVITY:
            this.classActivity = action.response;
            this.emit(Constants.GET_CLASS_ACTIVITY);
            break;
        case Constants.GET_STUDENT_ACTIVITY:
            this.studentActivity = action.response;
            this.emit(Constants.GET_STUDENT_ACTIVITY);
            break;
        case Constants.GET_STUDENT_ACTIVITY_NEW:
            this.studentActivityNew = action.response;
            this.emit(Constants.GET_STUDENT_ACTIVITY_NEW);
            break;
        case Constants.GET_ALL_STUDENTS_LIST:
            this.allStudents =  action.response;
            this.emit(Constants.GET_ALL_STUDENTS_LIST);
            break;
        case Constants.GET_CLASSES_LIST:
            this.list =  action.response;
            this.emit(Constants.GET_CLASSES_LIST);
            break;
        case Constants.GET_CLASS_DATA:
            this.lastClass =  action.response;
            this.emit(Constants.GET_CLASS_DATA);
            break;
        case Constants.GET_STUDENTS:
            this.students =  action.response;
            this.emit(Constants.GET_STUDENTS);
            break;
        case Constants.GET_TEACHERS:
            this.teachers =  action.response;
            this.emit(Constants.GET_TEACHERS);
            break;
            break;
    }

};

class ClassesStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.classes = {};
        this.students = [];
        this.list = [];
        this.lastClass = [];
        this.classList = [];
        this.archived1 = [];
        this.archived2 = [];
        this.favs = [];
    }

    getList(){
        return this.list || [];
    }

    getLastClass(){
        return this.lastClass || [];
    }

    setAccount(accountUID){
        this.activeAccountID = accountUID
    }

    get(ID)
    {
        return this.classes[ID] || {};
    }

    getMenu(){

    }

}

export default new ClassesStore();